// extracted by mini-css-extract-plugin
export default {"container":"NotFoundContainer_container__0e2bk"};